export default (date, hours) => {
  // Bug real (auditoría 2026-08-14): sin ninguna rama de fallback, un shape
  // que no fuera ISO-con-T/YYYY-MM-DD/Number (un Date ya construido, o un
  // timestamp serializado como STRING en vez de number) caía en un `return`
  // implícito (undefined) — varios callers (Treatment.js/Diagnosis.js/
  // Archive.js) encadenan .toLocaleDateString() directo sobre el resultado
  // sin optional chaining, así que eso crasheaba el render.
  if (date instanceof Date) {
    return date
  } else if (/^\d{4}-\d{2}-\d{2}T/.test(date)) {
    return new Date(date)
  } else if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return new Date(`${date}T${hours || '00:00'}`)
  } else if (date?.constructor?.name === 'Number' || (typeof date === 'string' && /^\d+$/.test(date))) {
    return new Date(Number(date))
  }
  return null
}
